<template>
    <div class="view report">
        <div class="uk-section">
            <report-form />
        </div>
    </div>
</template>

<script>
const ReportForm = () => import("../components/forms/ReportForm");
export default {
    name: 'ReportView',
    components: { ReportForm },
}
</script>
